import {
  SET_TIME_ZONE_ID,
  SET_DATE_RANGE,
  SET_EVENT_INSIGHTS_DATA,
  SET_LOADER_STATUS
} from './mutationTypes';

export default {
  [SET_TIME_ZONE_ID](state, timeZoneId) {
    state.dateRange.timeZoneId = timeZoneId;
  },

  [SET_DATE_RANGE](state, dateRangeDetails) {
    state.dateRange = {
      ...state.dateRange,
      ...dateRangeDetails
    };
  },

  [SET_EVENT_INSIGHTS_DATA](state, data) {
    state.eventInsightsData = data; 
  },

  [SET_LOADER_STATUS](state, status) {
    state.showLoader = status;
  }
};